const state = {
  income: [
    { name: '', type: 'header', weekly: 0 },
    { name: 'Take home pay', weekly: 0 },
    { name: 'Your partner\'s take home pay', weekly: 0 },
    { name: 'Bonuses and overtime', weekly: 0 },
    { name: 'Investment property income', weekly: 0 },
    { name: 'Income from savings and investments', weekly: 0 },
    { name: 'Dividends/shares', weekly: 0 },
    { name: 'Centerlink benefits', weekly: 0 },
    { name: 'Family benefit payments', weekly: 0 },
    { name: 'Child support received', weekly: 0 }
  ],
  realEstate: [
    { name: 'Property 1', type: 'header', weekly: 0 },
    { name: 'Mortgage/rent', weekly: 0 },
    { name: 'Body corprorate fees', weekly: 0 },
    { name: 'Council rates', weekly: 0 },
    { name: 'Water rates', weekly: 0 },
    { name: 'Gas rates', weekly: 0 },
    { name: 'Electricity', weekly: 0 },
    { name: 'Internet', weekly: 0 },
    { name: 'Landline phone', weekly: 0 },
    { name: 'Mobile phone', weekly: 0 },
    { name: 'Furniture/appliance replacement', weekly: 0 },
    { name: 'Furniture/appliance services', weekly: 0 },
    { name: 'Home and contents insurance', weekly: 0 }
  ],
  automotive: [
    { name: '', type: 'header', weekly: 0 },
    { name: 'Car insurances', weekly: 0 },
    { name: 'Rego/CTP', weekly: 0 },
    { name: 'Tyres', weekly: 0 },
    { name: 'Servicing', weekly: 0 },
    { name: 'Fuel/oil', weekly: 0 },
    { name: 'Tolls', weekly: 0 },
    { name: 'Car loans', weekly: 0 }
  ],
  livingExpenses: [
    { name: 'Insurance and Financial', type: 'header', weekly: 0 },
    { name: 'Personal and life insurance', weekly: 0 },
    { name: 'Health insurance', weekly: 0 },
    { name: 'Credit card interest', weekly: 0 },
    { name: 'Other loans', weekly: 0 },
    { name: 'Investment taxes', weekly: 0 },
    { name: 'Debt repayments', weekly: 0 },
    { name: 'Personal Savings', weekly: 0 },
    { name: 'Cash withdrawls', weekly: 0 },
    { name: 'Loans to family/friends', weekly: 0 },
    { name: 'Investments and superannuation contributions', weekly: 0 },
    { name: 'Voluntary repayments', weekly: 0 },
    { name: 'Charity donations', weekly: 0 },
    { name: 'Accountant / financial planner', weekly: 0 },
    { name: 'Legal fees', weekly: 0 },
    { name: 'Other', weekly: 0 },
    { name: 'Groceries', type: 'header', weekly: 0 },
    { name: 'Supermarket', weekly: 0 },
    { name: 'Butcher', weekly: 0 },
    { name: 'Fruit and vegetable markets', weekly: 0 },
    { name: 'Fish shop', weekly: 0 },
    { name: 'Deli and bakery', weekly: 0 },
    { name: 'Pet food', weekly: 0 },
    { name: 'Flowers', weekly: 0 },
    { name: 'Take away coffee', weekly: 0 },
    { name: 'Other take away foods', weekly: 0 },
    { name: 'Other', weekly: 0 },
    { name: 'Personal and medical', type: 'header', weekly: 0 },
    { name: 'Cosmetics and toiletries', weekly: 0 },
    { name: 'Hair and beauty', weekly: 0 },
    { name: 'Medicines and pharmacy', weekly: 0 },
    { name: 'Glasses and eye care', weekly: 0 },
    { name: 'Dental', weekly: 0 },
    { name: 'Doctors and medical', weekly: 0 },
    { name: 'Hobbies', weekly: 0 },
    { name: 'Clothing and shoes', weekly: 0 },
    { name: 'Jewellery and accessories', weekly: 0 },
    { name: 'Computers and technologies', weekly: 0 },
    { name: 'Sports and gym', weekly: 0 },
    { name: 'Education', weekly: 0 },
    { name: 'Other', weekly: 0 },
    { name: 'Pets', type: 'header', weekly: 0 },
    { name: 'Vet fees', weekly: 0 },
    { name: 'Dental', weekly: 0 },
    { name: 'Food', weekly: 0 },
    { name: 'Boarding fees', weekly: 0 },
    { name: 'Grooming', weekly: 0 },
    { name: 'Medication', weekly: 0 },
    { name: 'Other', weekly: 0 },
    { name: 'Entertainment', type: 'header', weekly: 0 },
    { name: 'Coffee and tea', weekly: 0 },
    { name: 'Purchased lunches', weekly: 0 },
    { name: 'Take away and snacks', weekly: 0 },
    { name: 'Cigarrettes', weekly: 0 },
    { name: 'Drinks and alcohol', weekly: 0 },
    { name: 'Bars and clubs', weekly: 0 },
    { name: 'Restaurants', weekly: 0 },
    { name: 'Functions/events', weekly: 0 },
    { name: 'Books', weekly: 0 },
    { name: 'Hobbies', weekly: 0 },
    { name: 'Newspapers and magazines', weekly: 0 },
    { name: 'Subscriptions', weekly: 0 },
    { name: 'Movies and music', weekly: 0 },
    { name: 'Holidays', weekly: 0 },
    { name: 'Celebrations and gifts', weekly: 0 },
    { name: 'Sporting/social club', weekly: 0 },
    { name: 'Other', weekly: 0 },
    { name: 'Transport and Auto', type: 'header', weekly: 0 },
    { name: 'Bus/train/ferry', weekly: 0 },
    { name: 'Taxi fees', weekly: 0 },
    { name: 'Petrol', weekly: 0 },
    { name: 'Road tolls', weekly: 0 },
    { name: 'Petrol', weekly: 0 },
    { name: 'Parking fees', weekly: 0 },
    { name: 'Drivers license', weekly: 0 },
    { name: 'Car service', weekly: 0 },
    { name: 'Tyres', weekly: 0 },
    { name: 'Fines', weekly: 0 },
    { name: 'Airfares', weekly: 0 },
    { name: 'Car washing', weekly: 0 },
    { name: 'Other', weekly: 0 }
  ],
  children: [
    { name: '', type: 'header', weekly: 0 },
    { name: 'Baby products', weekly: 0 },
    { name: 'Toys and crafts', weekly: 0 },
    { name: 'Babysitting', weekly: 0 },
    { name: 'Childcare', weekly: 0 },
    { name: 'Sports and activities', weekly: 0 },
    { name: 'School fees', weekly: 0 },
    { name: 'Excursions', weekly: 0 },
    { name: 'School uniforms', weekly: 0 },
    { name: 'School books/stationery', weekly: 0 },
    { name: 'Other school needs', weekly: 0 },
    { name: 'Holiday activities/care', weekly: 0 },
    { name: 'After school care/activities', weekly: 0 },
    { name: 'Transport costs', weekly: 0 },
    { name: 'Child support payment', weekly: 0 },
    { name: 'Pocket money', weekly: 0 },
    { name: 'Clothing', weekly: 0 },
    { name: 'Shoes', weekly: 0 },
    { name: 'Birthday presents', weekly: 0 },
    { name: 'Christmas presents', weekly: 0 },
    { name: 'Birthday party costs', weekly: 0 },
    { name: 'Friends birthday presents', weekly: 0 }
  ],
  summary: [
    { name: 'Summary', type: 'header', weekly: 0 },
    { name: 'Total Income', weekly: 0 },
    { name: 'Total Expenses', weekly: 0 },
    { name: 'Surplus', weekly: 0 }
  ]
}

const getters = {
  income (state) {
    return state.income
  },
  realEstate (state) {
    return state.realEstate
  },
  automotive (state) {
    return state.automotive
  },
  livingExpenses (state) {
    return state.livingExpenses
  },
  children (state) {
    return state.children
  },
  summary (state) {
    return state.summary
  }
}

const actions = {
  view ({ commit }) {
  },
  update ({ commit }) {
  }
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
